import { render, staticRenderFns } from "./Phpsst.vue?vue&type=template&id=675ab5c7&"
import script from "./Phpsst.vue?vue&type=script&lang=js&"
export * from "./Phpsst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports